import React from 'react';
import NoDataAndLoading from 'components/NoDataAndLoading';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import styles from './EmptyState.css';

class EmptyState extends React.Component {
  render() {
    const { showLoadingSpinner, hasRole, hasStaff } = this.props;
    const { title, description, linkLabel, linkUrl } = this._text();
    return (
      <NoDataAndLoading
        showLoadingSpinner={showLoadingSpinner}
        noDataToDisplay={!hasRole || !hasStaff}
        title={title}
        description={description}
        linkLabel={linkLabel}
        linkUrl={linkUrl}
      />
    );
  }

  _text = () => {
    const { hasRole, hasStaff } = this.props;
    if (hasRole && hasStaff) {
      return { title: '', description: '' };
    }
    if (hasRole && !hasStaff) {
      return {
        title: 'No employee information',
        description: '',
        linkLabel: 'Invite Employees to The Role',
        linkUrl:
          'https://mokaposhelp.zendesk.com/hc/id/articles/900000875526-Cara-Memasang-PIN-bagi-Karyawan-',
      };
    }
    //! hasRole
    return {
      title: 'No employee information',
      description: 'You must have at least one role to invite a employee',
    };
  };

  _footerElement = () => {
    const { hasRole, canAccessRole } = this.props;
    if (hasRole) {
      return false;
    }
    if (canAccessRole) {
      return (
        <Link
          to="/employees/role"
          className={`btn btn-primary btn-lg ${styles['btn-create-role']}`}
        >
          Create A Role
        </Link>
      );
    }
    const popover = (
      <Popover bsClass={`${styles.popover} popover`}>
        You're not authorized to access this privilege
      </Popover>
    );
    return (
      <OverlayTrigger placement="top" overlay={popover}>
        <a
          className={`btn btn-primary btn-lg ${styles['btn-create-role']} ${
            styles.disabled
          }`}
        >
          Create A Role
        </a>
      </OverlayTrigger>
    );
  };
}

EmptyState.propTypes = {
  hasRole: PropTypes.boolean,
  hasStaff: PropTypes.boolean,
  canAccessRole: PropTypes.boolean,
  showLoadingSpinner: PropTypes.boolean,
};

export default EmptyState;
